import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Loading from '../presentation/Loading';

class PageAuthorize extends React.Component {

  constructor( props ){
    super( props );
    this.state = {
      loading: true,
      groups: this.props.groups === undefined ? [] : this.props.groups,
      authorized: false,
    };
  }

  componentDidMount() {
    this.getUserGroups().then( ( usergroups ) => {
      this.setState( {
        authorized: this.checkUserGroupAccess( usergroups ),
        loading: false,
      } );
    } ).catch( ( exception ) => {
      this.setState( {
        authorized: false,
        loading: false,
      } );
    } );
  }

  componentWillReceiveProps( nextProps ) {
    this.getUserGroups().then( ( usergroups ) => {
      this.setState( {
        authorized: this.checkUserGroupAccess( usergroups ),
        loading: false,
      } );
    } ).catch( ( exception ) => {
      this.setState( {
        authorized: false,
        loading: false,
      } );
    } );
  }

  getUserGroups() {
    const auth = this.props.auth;
    const user = this.props.user;
    const profile = auth.getProfile( user );
    return new Promise( function( resolve, reject ) {
      try {
        if( profile !== undefined ) {
          resolve( profile.userGroups );
        } else {
          resolve( [] );
        }
      } catch ( e ) {
        reject( e );
      }
    } );
  }

  checkUserGroupAccess( usergroups ) {
    let ugindex = 0;
    const groups = this.state.groups;
    let gindex = 0;

    if( groups.length > 0 ) {
      if( usergroups.length > 0 ) {
        for( ugindex = 0; ugindex < usergroups.length; ugindex++ ) {
          let usergroup = usergroups[ugindex];
          for( gindex = 0; gindex < groups.length; gindex++ ) {
            let group = groups[gindex];
            if( usergroup.GROUP_NAME === group ) {
              return true;
            }
          } /* for(gindex = 0; gindex < groups.length; gindex++ ) */
        } /* for(ugindex = 0; ugindex < usergroups.length; ugindex++) */
      } /* if( usergroups.length > 0 ) */
    } /* if( groups.length > 0 ) */
    return false;
  }

  render() {
    if( this.state.loading === false ) {
      if( this.state.authorized === true ) {
        return (
          <div>
            {this.props.children}
          </div>
        );
      } else {
        return (
          <div style={{'display':'flex','alignItems':'center','justifyContent':'center','flex':'1 1 100%'}}>
            <Loading caption="Loading Please Wait..." borderWidth="1pt" borderColor="#C1C1C1" backgroundColor="#f1f1f1" borderRadius="10px" />
          </div>
        );
      }
    } else {
      return (
        <div>Authorizing...</div>
      );
    }
  }
}

export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( PageAuthorize ) );



// WEBPACK FOOTER //
// ./src/security/PageAuthorize.js